import React, { type FC, type RefObject, memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useDuplicatesAnalytic } from 'reactApp/hooks/duplicates/useDuplicatesAnalytic';
import { showBestPhotoTooltipStart } from 'reactApp/modules/duplicates/duplicates.actions';
import { REMOVE_ALL_DUPLICATES_TOOLTIP_ID } from 'reactApp/modules/duplicates/duplicates.constants';
import { getRemoveAllDuplicatesTooltipShown } from 'reactApp/modules/duplicates/duplicates.helpers';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './RemoveAllDuplicatesTooltip.css';

const text = 'Нажмите, чтобы\u00A0удалить все\u00A0дубликаты\u00A0— вам\u00A0не\u00A0придётся разбирать их\u00A0вручную';

interface IProps {
    target: RefObject<HTMLElement> | Element | null;
}

const onClose = () => {
    storeHelper.setValue(REMOVE_ALL_DUPLICATES_TOOLTIP_ID, true);
};

export const RemoveAllDuplicatesTooltip: FC<IProps> = memo(function (props: IProps) {
    const { target } = props;

    const analyticData = useDuplicatesAnalytic();
    const dispatch = useDispatch();

    const onShow = useCallback(() => {
        dispatch(showBestPhotoTooltipStart());
        sendPaymentGa({
            eventCategory: ECategoryGa.duplicates,
            action: 'tooltip-show',
            tooltip_type: 'clear-all',
            ...analyticData,
        });
    }, [analyticData]);

    if (getRemoveAllDuplicatesTooltipShown()) {
        return null;
    }

    return (
        <FloatingTooltip
            target={target}
            placement={ETooltipPlacement.bottom}
            size={ETooltipSize.fit}
            closeOnContextMenu={true}
            onClose={onClose}
            onShow={onShow}
            usePortal={true}
            closable={false}
            qaId="duplicates-remove-all-tooltip"
        >
            <div className={styles.root}>
                <span>{text}</span>
            </div>
        </FloatingTooltip>
    );
});

RemoveAllDuplicatesTooltip.displayName = 'RemoveAllDuplicatesTooltip';
